import {
  GET_SITEMAP_PENDING,
  GET_SITEMAP_SUCCESS,
  GET_SITEMAP_FAILURE,
} from '../actions';

export const initialState = {
  loading: true,
  tree: [],
};

export function sitemap(state = initialState, action) {
  switch (action.type) {
    case GET_SITEMAP_PENDING:
      return {
        ...state,
        loading: true,
      };
    case GET_SITEMAP_SUCCESS:
      return {
        ...state,
        loading: false,
        tree: action.payload || [],
      };
    case GET_SITEMAP_FAILURE:
      return {
        ...state,
        loading: false,
        tree: [],
      };
    default:
      return state;
  }
}
